export enum EnumLiquidationStatus {
    Pendiente,
    Aceptada,
    Rechazada
}